var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("Change the color")]),_c('button',{staticClass:"btn btn-light border-2 rounded-2 p-2 shadow m-3",on:{"click":_vm.generator}},[_vm._v("New color")]),_c('h3',[_vm._v(_vm._s(_vm.color))])])
}
var staticRenderFns = []

export { render, staticRenderFns }